module.exports = __webpack_public_path__ + "static/media/machine.6f3906a2.png";